// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-89ddb1d0] .user-dialog .el-dialog__body{padding:0 !important;height:600px}.btn-box[data-v-89ddb1d0]{padding:0 20px}[data-v-89ddb1d0].el-alert--success.is-light{background:#fff1e5 !important;font-size:12px;color:#ff7d00 !important}[data-v-89ddb1d0] .el-alert--success.is-light .el-alert__description{color:#ff7d00 !important}", ""]);
// Exports
module.exports = exports;
